import { useParams } from 'react-router-dom';

import { QuestionnaireMode } from '../config/DiactiveTypes';
import Questionnaire from '../components/questionnaires/Questionnaire';

const FillQuestionnaire = () => {
  const { phase, questionnaireId } = useParams();
  return (
    <Questionnaire
      mode={QuestionnaireMode.Fill}
      phase={phase}
      questionnaireId={questionnaireId}
    />
  );
};

export default FillQuestionnaire;